import * as React from "react";
const SvgDownload = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M11.252 1.69v11.314l-1.705-1.705-1.703-1.703-.532.529-.529.531 2.608 2.61L12 15.873l2.61-2.607 2.607-2.61-.53-.531-.53-.53-1.696 1.698c-.933.933-1.701 1.695-1.705 1.695-.004 0-.008-2.54-.008-5.648V1.69H12ZM3.283 17.624v4.504h17.434v-4.504h-1.498v2.996H4.78v-2.996h-.75z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgDownload;
